export default __webpack_public_path__ + "static/media/card.7830a350.jpg";